import React from 'react';

if (process.env.CLIENT) {
  require('./Page.scss'); // eslint-disable-line global-require
}

const Page = () => (
  <div className="gel-pica">
    <h3 className="error-500__header">Sorry, the server hit a problem</h3>
    <div className="error-500__image" />
    <p className="error-500__description">Please try again later&hellip;</p>
  </div>
);

export default Page;
